import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import * as service from '../services';
import { TimelineType } from '../types';

export const useAnaliseCoberturaTimeline = () => {
  const coberturaTimeline = async () => {
    const resp = await service.getAnaliseCoberturaTimeline();
    if (resp) return resp;

    return { data: {}, status: null };
  };

  const { isFetching, data, refetch } = useQuery(['cobertura-timeline'], coberturaTimeline, {
    retry: false,
  });

  useEffect(() => {
    if (data?.status === 204) {
      setTimeout(() => {
        refetch();
      }, 60000);
    }
  }, [data]);

  return {
    isLoadingTimeline: isFetching,
    timelineData: data?.data as TimelineType,
  };
};
